import { Entity } from '@betgames/bg-state-manager';
import { IGameMessageModel } from './interfaces';
import { GameMessagePlacement, GameMessageType } from './enums';

export default class GamesMessagesEntity extends Entity<IGameMessageModel, GameMessagePlacement> {
    private queues: Map<GameMessagePlacement, IGameMessageModel[]> = new Map();

    private timeouts: Map<GameMessagePlacement, number> = new Map();

    constructor() {
        super({
            key: 'GamesMessages',
            default: null,
        });
    }

    private setMessageFromQueue(placement: GameMessagePlacement): void {
        const message = this.queues.get(placement)[0];

        this.store(placement).update({
            type: GameMessageType.DEFAULT,
            ...message,
        });

        this.timeouts.set(
            placement,
            setTimeout(() => {
                const [, ...rest] = this.queues.get(placement);

                this.timeouts.delete(placement);
                this.queues.set(placement, rest);
                super.store(placement).reset();

                if (rest.length) {
                    this.setMessageFromQueue(placement);
                }
            }, message.timeout),
        );
    }

    public addToQueue(message: IGameMessageModel, placement = GameMessagePlacement.CENTER): void {
        if (!this.queues.has(placement)) {
            this.queues.set(placement, []);
        }

        this.queues.get(placement).push(message);

        if (!this.timeouts.has(placement)) {
            this.setMessageFromQueue(placement);
        }
    }

    public showMessage(message: IGameMessageModel, placement = GameMessagePlacement.CENTER): void {
        clearTimeout(this.timeouts.get(placement));
        this.timeouts.delete(placement);
        this.queues.set(placement, []);

        if (message.timeout) {
            this.addToQueue(message, placement);
        } else {
            this.store(placement).update({
                type: GameMessageType.DEFAULT,
                ...message,
            });
        }
    }

    public clearMessage(placement = GameMessagePlacement.CENTER): void {
        clearTimeout(this.timeouts.get(placement));
        this.timeouts.delete(placement);
        this.queues.delete(placement);

        super.store(placement).reset();
    }

    public resetMessages(): void {
        Object.values(GameMessagePlacement).forEach((placement) => {
            this.clearMessage(placement as GameMessagePlacement);
        });
    }
}
